<template>
  <v-chart class="line2" :option="option" />
</template>

<script>
import { getUserDateView } from "@/api/comd.js";
export default {
  data() {
    return {
      option: {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          data: ["课程学习人数", "虚仿实训人数"],
          left: 10,
          top: 10,
          textStyle: {
            color: "#fff",
          },
          icon: "rect",
        },
        grid: {
          left: "2%",
          right: "5%",
          bottom: "18%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: ["7/1", "7/2", "7/3", "7/4", "7/5", "7/6", "7/7"],
            axisLabel: {
              color: "rgba(255, 255, 255, 0.647058823529412)",
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            axisLabel: {
              color: "rgba(255, 255, 255, 0.647058823529412)",
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: "dashed",
                opacity: 0.3,
              },
            },
          },
        ],
        series: [
          {
            name: "课程学习人数",
            type: "line",
            stack: "Total",
            areaStyle: {
              color: "#37A8E8",
            },
            lineStyle: {
              color: "#37A8E8",
              opacity: 0,
            },
            emphasis: {
              focus: "series",
            },
            data: [3220, 3182, 2191, 2234, 1290, 2330, 1310],
          },
          {
            name: "虚仿实训人数",
            type: "line",
            stack: "Total",
            areaStyle: {
              color: "#1E72E4",
            },
            lineStyle: {
              color: "#1E72E4",
              opacity: 0,
            },
            emphasis: {
              focus: "series",
            },
            data: [3660, 3000, 2000, 2200, 1190, 2330, 3410],
          },
        ],
      },
    };
  },
  created() {
  
  },
  mounted(){
    this.getUserDateViewHandel();

  },
  methods: {
    async getUserDateViewHandel() {
      let res = await getUserDateView();
      this.dataViewCp = res.data;
      this.option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          data: ["课程学习人数", "虚仿实训人数"],
          left: 10,
          top: 10,
          textStyle: {
            color: "#fff",
          },
          icon: "rect",
        },
        grid: {
          left: "2%",
          right: "5%",
          bottom: "18%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.dataViewCp.map((en) => en.dateValue),
            axisLabel: {
              color: "rgba(255, 255, 255, 0.647058823529412)",
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            axisLabel: {
              color: "rgba(255, 255, 255, 0.647058823529412)",
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: "dashed",
                opacity: 0.3,
              },
            },
          },
        ],
        series: [
          {
            name: "课程学习人数",
            type: "line",
            stack: "Total",
            areaStyle: {
              color: "#37A8E8",
            },
            lineStyle: {
              color: "#37A8E8",
              opacity: 0,
            },
            emphasis: {
              focus: "series",
            },
            data: this.dataViewCp.map((en) => en.courseStudyUser),
          },
          {
            name: "虚仿实训人数",
            type: "line",
            stack: "Total",
            areaStyle: {
              color: "#1E72E4",
            },
            lineStyle: {
              color: "#1E72E4",
              opacity: 0,
            },
            emphasis: {
              focus: "series",
            },
            data: this.dataViewCp.map((en) => en.xfStudyUser),
          },
        ],
      };
    },
  },
};
</script>

<style scoped>
.test {
  background: red;
}
</style>